module.exports = __webpack_public_path__ + "img/menu.c11c8af9.svg";